
var id = "upload_btn";
var markup = "<symbol viewBox=\"0 0 24.0 24.0\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"upload_btn\"><defs><clipPath id=\"upload_btn_i0\"><path d=\"M1680,0 L1680,1343 L0,1343 L0,0 L1680,0 Z\" /></clipPath><clipPath id=\"upload_btn_i1\"><path d=\"M18,0 C20.21,0 22,1.79 22,4 C22,6.21 20.21,8 18,8 L7.5,8 C6.12,8 5,6.88 5,5.5 C5,4.12 6.12,3 7.5,3 L17,3 L17,4.5 L7.5,4.5 C6.95,4.5 6.5,4.95 6.5,5.5 C6.5,6.05 6.95,6.5 7.5,6.5 L18,6.5 C19.38,6.5 20.5,5.38 20.5,4 C20.5,2.62 19.38,1.5 18,1.5 L5.5,1.5 C3.29,1.5 1.5,3.29 1.5,5.5 C1.5,7.71 3.29,9.5 5.5,9.5 L17,9.5 L17,11 L5.5,11 C2.46,11 0,8.54 0,5.5 C0,2.46 2.46,0 5.5,0 Z\" /></clipPath></defs><g transform=\"translate(-322.0 -998.0)\"><g clip-path=\"url(#upload_btn_i0)\"><g transform=\"translate(280.0 145.0)\"><g transform=\"translate(32.0 848.0)\"><g transform=\"translate(11.5 11.5)\"><g clip-path=\"url(#upload_btn_i1)\"><polygon points=\"0,0 22,0 22,11 0,11 0,0\" stroke=\"none\" fill=\"#FAFAFA\" /></g></g></g></g></g></g></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
